module.exports = __webpack_public_path__ + "img/CQSSC30S.png";